import { mdiClose } from '@mdi/js';
import * as React from 'react';

interface PopUpFrameInsightProps {
    containerClass?: string;
    title?: string;
    onCloseClick?: () => void;
}

export function PopUpFrameInsight(
    props: React.PropsWithChildren<PopUpFrameInsightProps>,
): React.ReactElement {
    return (
        <div className={`insight-pop-up-frame ${props.containerClass}`}>
            <div className="d-flex align-items-center">
                <div className="col flex-grow-1 insight-title">
                    {props.title}
                </div>
                <button
                    className="btn bg-transparent"
                    tabIndex={-1}
                    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                    onClick={() => props.onCloseClick && props.onCloseClick()}
                >
                    <div className="d-inline cmps-icon cmps-cdk-fill-grey-300 hover:cmps-cdk-fill-grey-400">
                        <svg>
                            <path d={mdiClose}></path>
                        </svg>
                    </div>
                </button>
            </div>
            <div>{props.children}</div>
        </div>
    );
}
